import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs/internal/observable/throwError';
import { environment } from './../../../../environments/environment';
import { EquipmentCostSetting } from './../../_models/financials/equipmentCostSetting';

@Injectable()
export class EquipmentCostSettingService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getList(): Observable<EquipmentCostSetting[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/financial/equipmentCostSettings')
      .pipe(map((response) => response));
  }

  get(id: number): Observable<EquipmentCostSetting> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/financial/equipmentCostSettings/' + id)
      .pipe(map((response) => response));
  }

  save(equipmentCostSettingItem): Observable<EquipmentCostSetting> {
    const equipmentCostSetting = { ...equipmentCostSettingItem };
    delete equipmentCostSetting.lastUpdated;
    delete equipmentCostSetting.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    equipmentCostSetting.companyId = companySelected ? companySelected.id : null;

    if (equipmentCostSetting.user != null && equipmentCostSetting.user.id != null) {
      equipmentCostSetting.user = { id: equipmentCostSetting.user.id };
    }
    if (equipmentCostSetting.id) {
      return this.http
        .put<EquipmentCostSetting>(
          this.apiBaseUrl +
            'api/private/v1/financial/equipmentCostSettings/' +
            equipmentCostSetting.id,
          equipmentCostSetting
        )
        .pipe(
          catchError((error: any) => {
            return throwError(error);
          })
        );
    } else {
      return this.http
        .post<EquipmentCostSetting>(
          this.apiBaseUrl + 'api/private/v1/financial/equipmentCostSettings/',
          equipmentCostSetting
        )
        .pipe(
          catchError((error: any) => {
            return throwError(error);
          })
        );
    }
  }

  delete(equipmentCostSetting: EquipmentCostSetting): Observable<EquipmentCostSetting> {
    return this.http
      .delete(
        this.apiBaseUrl +
          'api/private/v1/financial/equipmentCostSettings/' +
          equipmentCostSetting.id
      )
      .pipe(
        map((response) => {
          return { id: equipmentCostSetting.id } as EquipmentCostSetting;
        })
      );
  }
}
